<template>
  <el-dialog title="其它" :visible.sync="visible" width="300px" @close="handleClose" class="settings-dialog">
    <div style="display: flex; justify-content: center; gap: 15px; padding: 0 10px;">
      <el-button @click="resetStatus" type="warning" :disabled="!isAssigned" style="flex: none; width: 120px; font-size: 12px; padding: 8px 4px; box-sizing: border-box;">重置本页面订正状态</el-button>
      <el-button @click="setAllFinished" type="success" :disabled="!isAssigned" style="flex: none; width: 120px; font-size: 12px; padding: 8px 4px; box-sizing: border-box;">设置本页面全部订完</el-button>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'MobileSettingsDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    isAssigned: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false);
    },
    resetStatus() {
      this.$emit('reset-status');
    },
    setAllFinished() {
      this.$emit('set-all-finished');
    }
  }
};
</script>

<style scoped>
/* 弹窗样式优化 */
.settings-dialog ::v-deep .el-dialog {
  border-radius: 15px !important;
  overflow: hidden;
  margin: 10px;
  width: calc(100% - 20px) !important;
}

.settings-dialog ::v-deep .el-dialog__header {
  background: linear-gradient(90deg, #409EFF, #64b5f6);
  color: white;
  padding: 15px 20px;
  transition: all 0.3s ease;
  position: relative;
}

.settings-dialog ::v-deep .el-dialog__headerbtn {
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  width: 25px;
  height: 25px;
  font-size: 20px;
  color: white;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.settings-dialog ::v-deep .el-dialog__headerbtn:hover {
  background-color: rgba(255, 255, 255, 0.2);
  transform: translateY(-50%) scale(1.1);
}

.settings-dialog ::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: white;
  font-weight: bold;
}

/* 语文主题弹窗头部 */
body.chinese-theme .settings-dialog ::v-deep .el-dialog__header {
  background: linear-gradient(90deg, #d2691e, #ff8c00);
}

/* 数学主题弹窗头部 */
body.math-theme .settings-dialog ::v-deep .el-dialog__header {
  background: linear-gradient(90deg, #1e90ff, #4169e1);
}

/* 英语主题弹窗头部 */
body.english-theme .settings-dialog ::v-deep .el-dialog__header {
  background: linear-gradient(90deg, #ff69b4, #ff1493);
}

.settings-dialog ::v-deep .el-dialog__title {
  color: white;
  font-weight: bold;
}

.settings-dialog ::v-deep .el-dialog__body {
  padding: 15px;
}

.settings-dialog ::v-deep .el-dialog__footer {
  padding: 12px 15px;
  background-color: #f5f7fa;
  transition: all 0.3s ease;
}

/* 语文主题弹窗底部 */
body.chinese-theme .settings-dialog ::v-deep .el-dialog__footer {
  background-color: #fff8dc;
}

/* 数学主题弹窗底部 */
body.math-theme .settings-dialog ::v-deep .el-dialog__footer {
  background-color: #f0f8ff;
}

/* 英语主题弹窗底部 */
body.english-theme .settings-dialog ::v-deep .el-dialog__footer {
  background-color: #fff0f5;
}

/* 按钮样式优化 */
.el-button {
  border-radius: 10px;
  font-weight: bold;
}

.el-button--danger:not(:disabled) {
  background: linear-gradient(90deg, #F56C6C, #ff8e8e);
  border: none;
}

.el-button--primary:not(:disabled) {
  background: linear-gradient(90deg, #409EFF, #64b5f6);
  border: none;
}

/* 语文主题主要按钮 */
body.chinese-theme .el-button--primary:not(:disabled) {
  background: linear-gradient(90deg, #d2691e, #ff8c00);
}

/* 数学主题主要按钮 */
body.math-theme .el-button--primary:not(:disabled) {
  background: linear-gradient(90deg, #1e90ff, #4169e1);
}

/* 英语主题主要按钮 */
body.english-theme .el-button--primary:not(:disabled) {
  background: linear-gradient(90deg, #ff69b4, #ff1493);
}

.el-button--success:not(:disabled) {
  background: linear-gradient(90deg, #67C23A, #95d475);
  border: none;
}

.el-button--warning:not(:disabled) {
  background: linear-gradient(90deg, #E6A23C, #f3d19e);
  border: none;
}

.el-button--danger:not(:disabled) {
  background: linear-gradient(90deg, #F56C6C, #ff8e8e);
  border: none;
}
</style>